import ko from './lang/ko.json'
import en from './lang/en.json'

export default {
  ko: ko,
  en: en
}
